const AccRecvPreview = () => import("@/views/base/AccRecvPreview.vue");
const AccRecvMap = () => import("@/views/base/AccRecvMap.vue");
const AccRecvProfile = () => import("@/views/base/AccRecvProfile.vue");

const accountRecRoutes = {
  mainRoute: "base/AccRecvPreview",
  children: [
    {
      path: "base/AccRecvPreview",
      name: "Issues Preview",
      component: AccRecvPreview
    },
    {
      path: "base/AccRecvMap",
      name: "Map By Region",
      component: AccRecvMap
    },
    {
      path: "accrecv",
      name: "Issues Profile",
      component: AccRecvProfile,
      props(route) {
        return route.query || {};
      }
    }
  ]
};

export default accountRecRoutes;
